import { useRef, useEffect, useCallback } from 'react';
import { trackLanding, trackExit, buildLandingTrackingData } from 'ai/analytics/trackers/pageTrackers';
import processEvent from 'analytics/processEvent';
import anaConsts from 'analytics/constants';

const useSuperChatAnalytics = ({ initialEntryPointData, isChatInitialized }) => {
    const hasTrackedLandingRef = useRef(false);
    const selectedPromptRef = useRef(null);
    const sourceRef = useRef(null);

    useEffect(() => {
        if (initialEntryPointData?.selectedPrompt && !selectedPromptRef.current) {
            selectedPromptRef.current = initialEntryPointData.selectedPrompt;
        }

        if (initialEntryPointData?.source && !sourceRef.current) {
            sourceRef.current = initialEntryPointData.source;
        }
    }, [initialEntryPointData]);

    useEffect(() => {
        if (isChatInitialized && !hasTrackedLandingRef.current) {
            hasTrackedLandingRef.current = true;
            const trackingData = buildLandingTrackingData(sourceRef.current, selectedPromptRef.current);
            processEvent.process(anaConsts.ASYNC_PAGE_LOAD, { data: trackingData });
        }
    }, [isChatInitialized]);

    const sendExitAnalytics = useCallback(() => {
        trackExit();
    }, []);

    return {
        sendExitAnalytics,
        trackLanding
    };
};

export default useSuperChatAnalytics;
